<template>
  <div>
    <!-- [ Modal form Add Vendor Form ] start -->
    <sweet-modal blocking :title="$t('vendors_addVendor')" ref="addVendorForm" class="modal" v-on:close="closeModal">

      <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">

        <el-card shadow="never" style="margin-bottom: 20px;">
          <h3>{{$t('modal_title_general')}}</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-row v-if="value">
                <el-form-item prop="value">
                  <el-input :value="value" @input="(val) => $emit('input', val)" size="mini" :label="$t('modal_name')"></el-input>
                </el-form-item>
              </el-row>
              <el-row v-else>
                <el-form-item prop="name">
                  <el-input v-model="form.name" size="mini" :label="$t('modal_name')"></el-input>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="shortName">
                <el-input v-model="form.shortName" size="mini" :label="$t('modal_short_name')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="taxNo">
                <el-input v-model="form.taxNo" size="mini" :label="$t('modal_tax_no')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="email">
                <el-input v-model="form.email" size="mini" :label="$t('modal_email')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="website">
                <el-input v-model="form.website" size="mini" :label="$t('modal_website')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="isAddressAssigned">
                <el-switch v-model="form.isAddressAssigned" :active-text="$t('modal_address')"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="form.isAddressAssigned" :gutter="20">
            <el-col :span="12">
              <el-form-item prop="countryId">
                <el-select no-data-text="no data" v-model="form.countryId" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
                  <el-option
                    v-for="item in arrCountryId"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="setState(item.id)">
                    <!-- @click.native="setState(item.id)" -->
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="stateId">
                <el-select no-data-text="no data" v-model="form.stateId" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
                  <el-option
                    v-for="item in arrStateId"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="setCity(item.id)">
                    <!-- @click.native="setCity(item.id)" -->
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="form.isAddressAssigned" :gutter="20">
            <el-col :span="12">
              <el-form-item prop="cityId">
                <el-select no-data-text="no data" v-model="form.cityId" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
                  <el-option
                    v-for="item in arrCityId"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="postCode">
                <el-input v-model="form.postCode" size="mini" :label="$t('modal_post_code')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="form.isAddressAssigned" :gutter="20">
            <el-col :span="12">
              <el-form-item prop="address">
                <el-input v-model="form.address" size="mini" :label="$t('modal_address_line_1')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="address2">
                <el-input v-model="form.address2" size="mini" :label="$t('modal_address_line_2')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="form.isAddressAssigned" :gutter="20">
            <el-col :span="12">
              <el-form-item prop="address3">
                <el-input v-model="form.address3" size="mini" :label="$t('modal_address_line_3')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="currencyId">
                <el-select v-model="form.currencyId" size="mini" :placeholder="$t('modal_currency')" style="width: 100%;">
                  <el-option v-for="item in currencyList"
                    :key="item.id"
                    :label="item.code"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="creditLimit">
                <el-input type="number" v-model="form.creditLimit" size="mini" :label="$t('modal_credit_limit')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <el-card shadow="never" style="margin-bottom: 20px;">
          <h3>{{$t('modal_title_bank_details')}}</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="bankName">
                <el-input v-model="form.bankName" size="mini" :label="$t('modal_bank_name')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="SWIFTCode">
                <el-input v-model="form.SWIFTCode" size="mini" :label="$t('modal_SWIFT_code')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="accountNo">
                <el-input v-model="form.accountNo" size="mini" :label="$t('modal_IBAN')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="paymentTermsId">
                <el-select v-model="form.paymentTermsId" size="mini" :label="$t('modal_payment_terms')" style="width: 100%">
                  <el-option v-for="item in paymentTermsList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('addVendorForm')">Cancel</el-button>
          <el-button @click="submitForm('form')" type="primary">Submit</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
    <!-- [ Modal form Add Vendor Form ] end -->

  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,

  },
  props: ['addVendorForm', 'directories', 'vendorName', 'value'],
  watch: {
    directories: function (val) {
      this.arrCountryId = this.directories.countryList
      this.arrStateId = this.directories.stateList
      this.arrCityId = this.directories.cityList
      this.currencyList = this.directories.currencies
    },
  },
  data() {
    return {
      currencyList: [],
      paymentTermsList: [{
        label: 'Cash Only',
        value: 1
      },{
        label: 'Due 15th Of the Following Month',
        value: 2
      },{
        label: 'Due By End Of The Following month',
        value: 3
      },{
        label: 'Payment due within 10 days',
        value: 4
      },{
        label: 'Prepaid',
        value: 5
      }],

      selectedTaskId: '',
      // Add Vendor Form
      arrCountryId: [],
      arrStateId: [],
      arrCityId: [],
      form: {
        // Basic Vendor Data
        name: '',
        shortName: null,
        taxNo: null,
        email: '',
        website: '',
        currencyId: null,

        // Purchasing
        bankName: null,
        SWIFTCode: null,
        accountNo: null,
        creditLimit: null,
        paymentTermsId: null,

        // Address
        isAddressAssigned: false,

        countryId: null,
        stateId: null,
        cityId: null,
        address: '',
        address2: '',
        address3: '',
        postCode: '',
      },
      rules: {
        name: [{
          required: true,
          message: 'Name is required',
          trigger: 'blur'
        }],
        shortName: [{
          required: true,
          message: 'Short Name is required',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: 'Email is required',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: 'Invalid email'
        }],
        // countryId: [{
        //   required: true,
        //   message: 'Country is required',
        //   trigger: 'change'
        // }],
        // stateId: [{
        //   required: true,
        //   message: 'State is required',
        //   trigger: 'change'
        // }],
        // cityId: [{
        //   required: true,
        //   message: 'City is required',
        //   trigger: 'change'
        // }],
        // street: [{
        //   required: true,
        //   message: 'Street is required',
        //   trigger: 'blur'
        // }],
        // postCode: [{
        //   required: true,
        //   message: 'Post Сode is required',
        //   trigger: 'blur'
        // }],
        // phone: [{
        //   required: true,
        //   message: 'Phone Сode is required',
        //   trigger: 'blur'
        // }],
        // fax: [{
        //   required: true,
        //   message: 'Fax Сode is required',
        //   trigger: 'blur'
        // }],

        // facebook: [{
        //   required: true,
        //   message: 'Facebook Сode is required',
        //   trigger: 'blur'
        // }],
        // linkedIn: [{
        //   required: true,
        //   message: 'Linked In Сode is required',
        //   trigger: 'blur'
        // }],
      }
    }
  },
  methods: {
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    closeModal() {
      this.$refs['form'].resetFields();
      this.form.countryId = null;
      this.form.stateId = null;
      this.form.cityId = null;
      this.form.postCode = null;
      this.form.address = '';
      this.form.address2 = '';
      this.form.address3 = ''
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    setState(id) {
      this.form.stateId = null;
      this.form.cityId = null;

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=getStateList&countryId=${id}`)
        .then(response => {
          console.log('---ADD VENDOR LIST', response.data);
          // this.arrCountryId = response.data.countryList
          this.arrStateId = response.data.stateList
          // this.arrCityId = response.data.cityList
        })
        .catch(error => {
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear()
          //   this.$router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
    },
    setCity(id) {
      this.form.cityId = null

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=getCityList&stateId=${id}`)
        .then(response => {
          console.log('---ADD VENDOR LIST', response.data);
          // this.arrCountryId = response.data.countryList
          // this.arrStateId = response.data.stateList
          this.arrCityId = response.data.cityList
        })
        .catch(error => {
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear()
          //   this.$router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.form.isAddressAssigned == true) {
            if (this.form.countryId &&
                this.form.stateId &&
                this.form.cityId &&
                this.form.address) {
                  if (this.form.website.length > 0) {
                    if (this.form.website.slice(0, 7) != 'http://' && this.form.website.slice(0, 8) != 'https://') {
                      this.form.website = 'http://' + this.form.website
                    }
                  }

                  let loader = this.$loading.show();
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  const data = {
                    // Basic Vendor Data
                    name: this.form.name || this.value,
                    shortName: this.form.shortName,
                    taxNo: this.form.taxNo,
                    email: this.form.email,
                    website: this.form.website,
                    currencyId: this.form.currencyId,

                    // Purchasing
                    bankName: this.form.bankName,
                    SWIFTCode: this.form.SWIFTCode,
                    accountNo: this.form.accountNo,
                    creditLimit: this.form.creditLimit,
                    paymentTermsId: this.form.paymentTermsId,

                    // Address
                    isAddressAssigned: this.form.isAddressAssigned,
                    countryId: this.form.countryId,
                    stateId: this.form.stateId,
                    cityId: this.form.cityId,
                    address: this.form.address,
                    address2: this.form.address2,
                    address3: this.form.address3,
                    postCode: this.form.postCode
                  };

                  const personData = {
                    firstname: this.form.name || this.value,
                    lastname: this.form.shortName,
                    email: this.form.email,
                    countryId: null,
                    stateId: null,
                    cityId: null,
                    workPhone: null,
                    mobilePhone: null,
                    skype: null,
                    facebook: null,
                    linkedin: null,
                    postCode: null,
                    isAddressAssigned: false,
                    address: null,
                    address2: null,
                    address3: null,
                  };
                  axios
                    .post(`/api/v1/companyVendors/create?companyId=${this.$route.query.companyId}`, data)
                    .then(response => {
                      console.log('---', response.data);
                      this.createPerson(personData, response.data.companyVendorId, this.value);
                      this.$store.dispatch('getRowDataVendors');
                      this.$store.dispatch('getMenuStatistics');
                      this.$refs.addVendorForm.close();
                      this.notification("Success", "Add Vendor", "success");

                      this.$emit('selected', response.data.companyVendorId);
                      loader.hide();
                      if(this.$route.name === 'expenses' || this.$route.name === 'projects'){
                        let newVendor = {
                          name: this.value || this.form.name,
                          id: response.data.companyVendorId
                        };
                        console.log('newVendor', newVendor);
                        this.$emit('setTask', this.selectedTaskId, newVendor)
                      }
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                      loader.hide()
                    });
            } else {
              this.$notify({
                title: 'Notification',
                message: 'Enter all fields Vendor Address',
                type: 'info'
              });
            }
          } else {
            this.form.countryId = null
            this.form.stateId = null
            this.form.cityId = null
            this.form.postCode = null
            this.form.address = ''
            this.form.address2 = ''
            this.form.address3 = ''

            if (this.form.website.length > 0) {
              if (this.form.website.slice(0, 7) != 'http://' && this.form.website.slice(0, 8) != 'https://') {
                this.form.website = 'http://' + this.form.website
              }
            }
            console.log('submit');
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            const data = {
              // Basic Vendor Data
              name: this.form.name || this.value,
              shortName: this.form.shortName,
              taxNo: this.form.taxNo,
              email: this.form.email,
              website: this.form.website,
              currencyId: this.form.currencyId,

              // Purchasing
              bankName: this.form.bankName,
              SWIFTCode: this.form.SWIFTCode,
              accountNo: this.form.accountNo,
              creditLimit: this.form.creditLimit,
              paymentTermsId: this.form.paymentTermsId,

              // Address
              isAddressAssigned: this.form.isAddressAssigned,
              countryId: this.form.countryId,
              stateId: this.form.stateId,
              cityId: this.form.cityId,
              address: this.form.address,
              address2: this.form.address2,
              address3: this.form.address3,
              postCode: this.form.postCode
            };

            const personData = {
              firstname: this.form.name || this.value,
              lastname: this.form.shortName,
              email: this.form.email,
              countryId: null,
              stateId: null,
              cityId: null,
              workPhone: null,
              mobilePhone: null,
              skype: null,
              facebook: null,
              linkedin: null,
              postCode: null,
              isAddressAssigned: false,
              address: null,
              address2: null,
              address3: null,
            };
            axios
              .post(`/api/v1/companyVendors/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.createPerson(personData, response.data.companyVendorId, this.value);
                console.log('---', response.data);
                this.$store.dispatch('getRowDataVendors')
                this.$store.dispatch('getMenuStatistics');
                this.$refs.addVendorForm.close();
                this.notification("Success", "Add Vendor", "success");

                this.$emit('selected', response.data.companyVendorId)
                loader.hide()
                if(this.$route.name === 'expenses' || this.$route.name === 'projects'){
                  let newVendor = {
                    name: this.value || this.form.name,
                    id: response.data.companyVendorId
                  }
                  console.log('newVendor', newVendor)
                  this.$emit('setTask', this.selectedTaskId, newVendor)
                }
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          }

          // if (this.form.website.length > 0) {
          //   if (this.form.website.slice(0, 7) != 'http://' && this.form.website.slice(0, 8) != 'https://') {
          //     this.form.website = 'http://' + this.form.website
          //   }
          // }
          // console.log('submit');
          // let loader = this.$loading.show();
          // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          // axios
          //   .post(`/api/v1/companyVendors/create?companyId=${this.$route.query.companyId}`, {
          //     name: this.form.name || this.value,
          //     email: this.form.email,
          //     website: this.form.website,
          //     countryId: this.form.countryId,
          //     stateId: this.form.stateId,
          //     cityId: this.form.cityId,
          //     // street: this.form.street,
          //     postCode: this.form.postCode,
          //     phone: this.form.phone,
          //     fax: this.form.fax,
          //     isAddressAssigned: this.form.isAddressAssigned,
          //     address: this.form.address,
          //     address2: this.form.address2,
          //     address3: this.form.address3,

          //     manual: this.form.manual,
          //     forms: this.form.forms,
          //     spareParts: this.form.spareParts,
          //   })
          //   .then(response => {
          //     console.log('---', response.data);
          //     this.$store.dispatch('getRowDataVendors')
          //     this.$store.dispatch('getMenuStatistics');
          //     this.$refs.addVendorForm.close();
          //     this.notification("Success", "Add Vendor", "success");

          //     this.$emit('selected', response.data.companyVendorId)
          //     loader.hide()
          //     if(this.$route.name === 'expenses' || this.$route.name === 'projects'){
          //       let newVendor = {
          //         name: this.value || this.form.name,
          //         id: response.data.companyVendorId
          //       }
          //       console.log('newVendor', newVendor)
          //       this.$emit('setTask', this.selectedTaskId, newVendor)
          //     }
          //   })
          //   .catch(error => {
          //     console.log('An error occurred:', error);
          //     loader.hide()
          //   });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    createPerson(form, vendorId, value){
      console.log('form', form);
      console.log('vendorId', vendorId);
      console.log('value', value);
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
              .post(`/api/v1/companyVendorPersons/create?companyId=${this.$route.query.companyId}&companyVendorId=${vendorId}`, {
                firstname: form.firstname,
                lastname: form.lastname,
                email: form.email,
                countryId: form.countryId,
                stateId: form.stateId,
                cityId: form.cityId,
                workPhone: form.workPhone,
                mobilePhone: form.phone,
                skype: form.skype,
                facebook: form.facebook,
                linkedin: form.linkedIn,
                postCode: form.postCode,
                isAddressAssigned: form.isAddressAssigned,
                address: form.address,
                address2: form.address2,
                address3: form.address3,
              })
              .then(response => {
                this.notification("Success", "Add Persons", "success");
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
    }
  },
}
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
.vendor-name{
  margin-left:57px;
  display:flex;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  span{
    margin-right:10px;
  }
}
</style>

<style lang="scss">
.countryInput {
  input {
    width: 110px !important;
  }
}
</style>
